import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Paper } from "@material-ui/core";

import VirtualFolderBreadcrumbs from "./VirtualFolderBreadcrumbs";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > * + *": {
        marginTop: theme.spacing(2),
      },
      display: "flex",
      justifyContent: "space-between",
      padding: "0.25rem 1rem",
      marginTop: "0",
    },
    count: {
      fontSize: "0.9rem",
    },
  })
);

interface Props {
  path: string;
  configId: number;
  excludes: string[];
  count: number;
  onClick: (path: string, configId: number) => void;
}

/** 仮想フォルダー情報ペイン */
export function VirtualFolderInfoPane(props: Props) {
  const classes = useStyles();

  const { path, configId, excludes, count, onClick } = props;

  // [Handler]
  const handleBreadcrumbsClick = (clickPath: string, configId: number) => {
    onClick(clickPath, configId);
  };

  //--------------------
  // コンポーネント
  return (
    <Paper className={classes.root}>
      {/* パンくずリスト */}
      <VirtualFolderBreadcrumbs
        path={path}
        configId={configId}
        excludes={excludes}
        onClick={handleBreadcrumbsClick}
      />
      {/* 件数 */}
      <Typography className={classes.count} style={{ marginTop: "0px" }}>
        {`${count} 件`}
      </Typography>
    </Paper>
  );
}
